module.exports = {
  schedule:{
    weekdays: {
      1: "Monday",
      2: "Tuesday",
      3: "Wednesday",
      4: "Thursday",
      5: "Friday",
      6: "Saturday",
      7: "Sunday"
    },
    allShows: "<i class=\"fa fa-search\"></i> All Shows",
    calendar: "<i class=\"fa fa-calendar\"></i> Calendar",
  },
  shows: {
    backToShows: "Back to Schedule"
  }
}


// WEBPACK FOOTER //
// ./src/lang/eng.js